<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onMove($event)"
     (pointerup)="onUp($event)"
     (pointercancel)="onUp($event)"
     (pointerleave)="onUp($event)">

  <defs>
    <radialGradient id="ft-panel" cx="50%" cy="30%" r="90%">
      <stop offset="0%" stop-color="#3a2a6b" />
      <stop offset="55%" stop-color="#241a4d" />
      <stop offset="100%" stop-color="#160f33" />
    </radialGradient>
  </defs>

  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0"
        fill="url(#ft-panel)" stroke="rgba(255,255,255,0.14)" stroke-width="2" />

  <!-- Starfield -->
  <g fill="#ffffff">
    <circle cx="160" cy="70" r="2" opacity="0.5" /><circle cx="470" cy="55" r="1.6" opacity="0.35" />
    <circle cx="760" cy="80" r="2.2" opacity="0.55" /><circle cx="920" cy="120" r="1.5" opacity="0.4" />
    <circle cx="90" cy="140" r="1.6" opacity="0.4" />
  </g>

  <!-- Number line -->
  <g class="numline" stroke="#eef3ff" stroke-width="4" stroke-linecap="round">
    <line [attr.x1]="X0 - 34" [attr.y1]="LINE_Y" [attr.x2]="X_END + 34" [attr.y2]="LINE_Y" />
    <polyline [attr.points]="(X0 - 34) + ',' + (LINE_Y - 11) + ' ' + (X0 - 48) + ',' + LINE_Y + ' ' + (X0 - 34) + ',' + (LINE_Y + 11)" fill="none" />
    <polyline [attr.points]="(X_END + 34) + ',' + (LINE_Y - 11) + ' ' + (X_END + 48) + ',' + LINE_Y + ' ' + (X_END + 34) + ',' + (LINE_Y + 11)" fill="none" />
  </g>

  <!-- Minor ticks (every 1/den) -->
  <line *ngFor="let t of minorTicks" class="minor-tick" [class.major]="isMajor(t)"
        [attr.x1]="dthToX(t)" [attr.y1]="LINE_Y - (isMajor(t) ? 16 : 9)"
        [attr.x2]="dthToX(t)" [attr.y2]="LINE_Y + (isMajor(t) ? 16 : 9)" />
  <!-- Integer labels -->
  <text *ngFor="let n of integerTicks" class="int-label"
        [attr.x]="dthToX(n * den)" [attr.y]="LINE_Y + 52" text-anchor="middle">{{ n }}</text>

  <!-- Start (A) ghost marker + flag -->
  <g class="ghost" *ngIf="round">
    <line [attr.x1]="ghostX" [attr.y1]="LINE_Y" [attr.x2]="ghostX" [attr.y2]="LINE_Y - 92" />
    <g [attr.transform]="'translate(' + ghostX + ',' + (LINE_Y - 116) + ')'">
      <rect class="ghost-flag" [attr.x]="-(startLabel.length * 11 + 20)" y="-26"
            [attr.width]="startLabel.length * 22 + 40" height="52" rx="10" />
      <text class="ghost-text" x="0" y="2" text-anchor="middle" dominant-baseline="central">{{ startLabel }}</text>
    </g>
    <circle class="ghost-dot" [attr.cx]="ghostX" [attr.cy]="LINE_Y" r="9" />
  </g>

  <!-- Jump arc from start to current marker -->
  <g *ngIf="jumpArc">
    <path class="jump-arc" [attr.d]="jumpArc" [attr.stroke]="opColor" />
    <text class="jump-label" [attr.x]="jumpMidX" [attr.y]="LINE_Y - 58" text-anchor="middle" [attr.fill]="opColor">
      {{ movedLabel }}
    </text>
  </g>

  <!-- Sparkles -->
  <g *ngIf="solvedState">
    <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [style.animation-delay.ms]="s.delay" fill="#fff4b0" />
  </g>

  <!-- Draggable marker + value flag -->
  <g class="marker" [class.win]="solvedState" [attr.transform]="'translate(' + markerX + ',0)'">
    <line [attr.x1]="0" [attr.y1]="LINE_Y" [attr.x2]="0" [attr.y2]="LINE_Y + 84" class="marker-stem" />
    <g [attr.transform]="'translate(0,' + (LINE_Y + 112) + ')'">
      <rect class="marker-flag" x="-52" y="-30" width="104" height="60" rx="12" />
      <text class="marker-text" x="0" y="2" text-anchor="middle" dominant-baseline="central">{{ markerLabel }}</text>
    </g>
    <circle class="marker-dot" [attr.cx]="0" [attr.cy]="LINE_Y" r="15" />
  </g>

  <!-- Full-width drag band over the line -->
  <rect class="drag-band" [attr.x]="X0 - 30" [attr.y]="LINE_Y - 40"
        [attr.width]="span + 60" height="80" fill="transparent" (pointerdown)="onDown($event)" />

  <!-- Wrong wash -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" rx="0" />
</svg>
